import fetch from '../../utils/fetchService';

import { handleErrors, parseAsJson } from '../../utils/requestHelpers';
import { QueryKeys, useCustomQuery } from '../../shared/queries';
import { Option } from '../../shared/types/common';
import Config from '../../config';

export type ReportParamOptions = Record<string, Option[]>;

type UseReportParamsOptionsResults = {
  options: ReportParamOptions,
  defaultValues: Record<string, { value: string | null }>
}

export const useReportParamsOptions = ({
  reportName,
  reportParamValues,
  onSuccess,
} : {
  reportName: string,
  reportParamValues: Record<string, string>,
  onSuccess: (data: UseReportParamsOptionsResults) => void
}) => useCustomQuery<UseReportParamsOptionsResults>(
  [QueryKeys.batchReports.ReportParams, reportName],
  {
    customFetch: async () => {
      if (!reportName || !Object.keys(reportParamValues)) {
        return {};
      }
      return await fetch(
        Config.endpoints.FETCH_BATCH_REPORTS_OPTIONS_FOR_REPORT
          .replace(':reportName', reportName),
        {
          method: 'POST',
          body: JSON.stringify({ reportParamValues }),
        }
      )
        .then(handleErrors({ errorMessage: 'Fetching Report Params failed' }))
        .then(parseAsJson);
    },
    defaultData: {
      options: {},
      defaultValues: {},
    },
    onSuccess,
  });
